import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactModal from 'react-modal';
import { getTNCDialogAttributes } from '../../selectors/uiSelectors';
import {
  toggleHideDialog,
  closeTNC,
  acceptTNC,
  changeCheckBoxValue,
} from '../../actions/uiActions';
import { getTncUrls } from '../../modules/settings/selectors/tncSelectors';
import { t } from '../../locales';

import './styles.scss';

interface EmmaModalTNCProps {
  tncDialog: any;
  closeTNC: any;
  acceptTNC: any;
  onChangeCheckBox: any;
  tncUrls: { [id: string]: string };
}

interface EmmaModalTNCState {}

class EmmaModalTNC extends Component<EmmaModalTNCProps, EmmaModalTNCState> {
  render() {
    const { tncDialog, closeTNC, acceptTNC } = this.props;

    let modalClass, closeButton;
    if (tncDialog) {
      modalClass = 'emma-modal-tnc';
      closeButton = (
        <button
          className="emma-modal-tnc__close"
          onClick={() => closeTNC(tncDialog.closeAction)}
          data-enable-ga
          data-ga-type="button"
        >
          {' '}
          {t('TNC_MODAL_CLOSE')}{' '}
        </button>
      );
    }

    const { tnc_first_checkbox, tnc_second_checkbox, tnc_third_checkbox, tnc_4_checkbox, tnc_5_checkbox, tnc_6_checkbox } =
      this.props.tncDialog;
    const { onChangeCheckBox } = this.props;

    return (
      <div>
        {tncDialog && (
          <ReactModal
            isOpen={tncDialog.visible}
            contentLabel="Minimal Modal Example"
            className={modalClass}
            overlayClassName="emma-modal__overlay"
            appElement={document.getElementById('root') || undefined}
          >
            <div className="emma-modal-tnc-wrapper">
              <h1 className="emma-modal-tnc__title">
                {t('TNC_MODAL_TITLE')}
                {closeButton}
              </h1>
              <div className="emma-modal-tnc__body">
                <div className="emma-stylesheet-checkbox-big mb16">
                  <input
                    name="tnc_first_checkbox"
                    type="checkbox"
                    onChange={() => onChangeCheckBox('tnc_first_checkbox')}
                    checked={tnc_first_checkbox}
                    id="tnc_first_checkbox"
                  />
                  <label htmlFor="tnc_first_checkbox">
                    <span>
                      {t('TNC_MODAL_TNC_1')}
                      <a
                        href={this.props.tncUrls.TNC}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-enable-ga
                        data-ga-type="link"
                      >
                        {t('TNC_MODAL_TNC_2')}
                      </a>
                      {t('TNC_MODAL_TNC_3')}
                    </span>
                  </label>
                  {tnc_first_checkbox === false && (
                    <span className="emma__help-block help-block-checkbox">
                      <span>{t('TNC_MODAL_TNC_ERROR')}</span>
                    </span>
                  )}
                </div>
                <div className="emma-stylesheet-checkbox-big mb16">
                  <input
                    name="tnc_third_checkbox"
                    type="checkbox"
                    onChange={() => onChangeCheckBox('tnc_third_checkbox')}
                    checked={tnc_third_checkbox}
                    id="tnc_third_checkbox"
                  />
                  <label htmlFor="tnc_third_checkbox">
                    {t('TNC_MODAL_PIC_1')}
                    <a
                      href={this.props.tncUrls.PIC}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-enable-ga
                      data-ga-type="link"
                    >
                      {t('TNC_MODAL_PIC_2')}
                    </a>
                    {t('TNC_MODAL_PIC_3')}
                  </label>
                  {tnc_third_checkbox === false && (
                    <span className="emma__help-block help-block-checkbox">
                      <span>{t('TNC_MODAL_PIC_ERROR')}</span>
                    </span>
                  )}
                </div>
                <div className="emma-stylesheet-checkbox-big mb16">
                  <input
                    name="tnc_second_checkbox"
                    type="checkbox"
                    onChange={() => onChangeCheckBox('tnc_second_checkbox')}
                    checked={tnc_second_checkbox}
                    id="tnc_second_checkbox"
                  />
                  <label htmlFor="tnc_second_checkbox">
                    <span>{t('TNC_MODAL_MARKETING')}</span>
                  </label>
                </div>
                {/* {[4,5,6].map((n, i) => {
                  const key = `tnc_${n}_checkbox`;
                  const value = this.props.tncDialog[key];
                  return (
                    <div key={key} className={"emma-stylesheet-checkbox-big " + (n === 6 ? '' : 'mb16')}>
                      <input
                        name={key}
                        type="checkbox"
                        onChange={() => onChangeCheckBox(`tnc_${n}_checkbox`)}
                        checked={value}
                        id={key}
                      />
                      <label htmlFor={key}>
                        {t(`TNC_MODAL_PIPL_${i + 1}`)}
                      </label>
                      {value === false && (
                        <span className="emma__help-block help-block-checkbox">
                          <span>{t(`TNC_MODAL_PIPL_ERROR_${i + 1}`)}</span>
                        </span>
                      )}
                    </div>
                  )
                })} */}
                <div className="emma-modal-tnc__btn-wrapper">
                  {tnc_first_checkbox && tnc_third_checkbox ? (
                    <button
                      className="emma-stylesheet-primary-default-button"
                      onClick={() => acceptTNC(tncDialog.okAction)}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      {t('TNC_MODAL_OK')}
                    </button>
                  ) : (
                    <button className="emma-stylesheet-primary-secondary-default-disabled-button">
                      {t('TNC_MODAL_OK')}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </ReactModal>
        )}
      </div>
    );
  }

  static mapStateToProps(state: any) {
    return {
      tncDialog: Object.assign({}, getTNCDialogAttributes(state)), // {visible, box1, bo2, box3}
      tncUrls: getTncUrls(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      closeTNC: (payload: any) => dispatch(closeTNC(payload)),
      acceptTNC: (payload: any) => dispatch(acceptTNC(payload)),
      toggleHideDialog: () => dispatch(toggleHideDialog()),
      // TODO [1]
      onChangeCheckBox: (name: any) => dispatch(changeCheckBoxValue(name)),
    };
  }
}

export default connect(
  EmmaModalTNC.mapStateToProps,
  EmmaModalTNC.mapDispatchToProps,
)(EmmaModalTNC);
